'use client';

import Image from 'next/image';
import React from 'react';
import CircledChevron from 'assets/images/CircledChevron.svg';
import { useTranslations } from 'next-intl';
import styles from './LearnMoreButton.module.css';

interface LearnMoreButtonProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({
  onClick,
  className,
  style,
}) => {
  const t = useTranslations('common');
  return (
    <button
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={style}
      onClick={onClick}
    >
      <span className="learn-more-text">
        {t('learnMoreButton.text.learnMore')}
      </span>
      <div className="learn-more-arrow">
        <Image src={CircledChevron} alt="chevron_right" width={12} height={17} />
      </div>
    </button>
  );
};
